// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d7f093cb0c027e557bf0","678":"5a0f365a1de44d810eef","883":"ca2a2f0bdee7d0966e65"}[chunkId] + ".js";
};